module.exports = __webpack_public_path__ + "img/join_now.a099a8f0.svg";